export default __webpack_public_path__ + "static/media/kitchen5-beforeE-768w.523b6cb6.webp";